<template>
  <div id="eap">
    <div
      class="page-header bg-brand-secondary"
      v-if="pageData && pageData.defaults"
    >
      <div class="content-container" v-if="$store.getters.isIE && skin === 8">
        <div class="page-title col-md-7 col-sm-12">
          <h2>{{ pageData.defaults.eap_title }}</h2>
          <p>
            {{ componentText.boiIeIntro }}
          </p>
        </div>
        <div class="call-us col-md-5 col-sm-12 ">
          <div class="numbers-box">
            <img class="mb-4" src="/img/boi/laya-logo.png" />
            <h3 class="text-white pt-2 pb-1">{{ componentText.callUsOn }}</h3>
            <h3 class="text-white  py-1">
              {{ componentText.ROI }}
              <a class="text-white" href="tel:1800911909">1800 911 909</a>
            </h3>
            <h3 class="text-white  pt-1 pb-2">
              {{ componentText.UK }}
              <a class="text-white" href="tel:08000988350">0800 0988 350</a>
            </h3>
          </div>
          <div class="text-left" v-if="pageData.defaults.request_cta">
            <button class="link-btn" @click="callBack">
              {{ componentText.callback }}
            </button>
          </div>
        </div>
      </div>
      <div class="content-container row" v-else-if="contentLoading">
        <b-spinner></b-spinner>
      </div>
      <!--      START OF HA CHANGES-->
      <div v-else-if="skin === 30 || skin === 35">
        <div class="content-container row">
          <div class="page-title col-12">
            <h2>{{ pageData.defaults.eap_title }}</h2>
          </div>
          <div class="page-title col-md-12 col-lg-6">
            <p v-html="pageData.defaults.eap_intro"></p>
          </div>
          <div
            class="call-us col-md-12 col-lg-6"
            v-if="pageData.defaults && pageData.defaults.video_on"
          >
            <div class="video-wrap">
              <video
                width="100%"
                class="video"
                controls
                controlsList="nodownload"
                :poster="'/img/eap/EAP-placeholder.png'"
              >
                <source :src="pageData.defaults.video_url" />
              </video>
            </div>
          </div>
        </div>
        <div class="numbersBanner">
          <div class="content-container">
            <div class="innerBanner">
              <div class="phoneNumberContainer">
                <div
                  v-for="phone in pageData.defaults.eap_phone"
                  class="phoneNumber"
                >
                  <a :href="getPhoneLink(phone)"
                    >{{ phone[0] }} <br />
                    <span>{{ phone[1] }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-container link-btn-container">
          <b-button
            v-if="isDmhButtonShown"
            variant="continue"
            class="dmh-button mt-3"
            @click="bookDmhSession"
          >
            <span></span>
            <span>{{ componentText.dmhButton }}</span>
            <i class="fa fa-arrow-right brand-primary" aria-hidden="true"></i>
          </b-button>
          <button
            class="link-btn"
            @click="goToService('Mental wellbeing support')"
          >
            Request a call back
          </button>
        </div>
      </div>
      <!--      END OF HA CHANGES-->
      <div class="content-container row" v-else>
        <div class="page-title col-12">
          <h2>{{ pageData.defaults.eap_title }}</h2>
        </div>
        <div class="page-title col-md-12 col-lg-6">
          <p v-html="pageData.defaults.eap_intro"></p>
          <h3
            class="text-white pt-2 pb-1"
            v-if="skin === 8 || pageData.defaults.eap_phone"
          >
            {{ componentText.callUsOn }}
          </h3>
          <div v-if="skin === 8">
            <!-- BOI default -->
            <h3 class="text-white  py-1">
              {{ componentText.ROI }}
              <a class="text-white" href="tel:1800911909">1800 911 909</a>
            </h3>
            <h3 class="text-white  pt-1 pb-2">
              {{ componentText.UK }}
              <a class="text-white" href="tel:08000988350">0800 0988 350</a>
            </h3>
          </div>
          <div v-else-if="pageData.defaults.eap_phone">
            <h3
              class="text-white  py-2"
              v-for="(phone, i) in pageData.defaults.eap_phone"
              :key="i"
            >
              <a
                class="text-white"
                :href="'tel:' + decodeURIComponent(phone[1])"
                >{{ phone[0] }}: {{ phone[1] }}</a
              >
            </h3>
          </div>
          <b-button
            v-if="isDmhButtonShown"
            variant="continue"
            class="dmh-button"
            @click="bookDmhSession"
          >
            <span></span>
            <span>{{ componentText.dmhButton }}</span>
            <i class="fa fa-arrow-right brand-primary" aria-hidden="true"></i>
          </b-button>
          <div
            class="text-center d-flex flex-column text-md-left justify-content-md-start justify-content-center"
            v-if="pageData.defaults.request_cta"
          >
            <button class="link-btn" @click="callBack">
              {{ componentText.callback }}
            </button>
          </div>
        </div>
        <div
          class="call-us col-md-12 col-lg-6"
          v-if="pageData.defaults && pageData.defaults.video_on"
        >
          <div class="video-wrap">
            <iframe
              v-if="isVimeoVideo"
              class="video"
              :src="vimeoEmbedUrl"
              width="100%"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
            <video
              v-else
              width="100%"
              class="video"
              controls
              controlsList="nodownload"
              :poster="'/img/eap/EAP-placeholder.png'"
            >
              <source :src="pageData.defaults.video_url" />
            </video>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div
        class="bg-grey py-5 px-md-5"
        v-if="
          pageData.defaults &&
            pageData.services_offered &&
            pageData.services_offered.active &&
            filteredServices.length !== 0
        "
      >
        <div class="content-container row services-offered">
          <div class="section-header section-header-right">
            <div class="section-header-divider"></div>
            <h3 class="section-header-title" v-if="$store.getters.skin !== 25">
              {{ componentText.services }}
            </h3>
            <h3 class="section-header-title" v-else>How we do this</h3>
          </div>
          <div
            v-for="card in pageData.services_offered.items"
            class="eap-cards col-md-3 col-sm-6 mb-4"
            v-if="card.active"
          >
            <div class="eap-card">
              <div class="row align-items-center">
                <div class="col-12 col-lg-5 pr-lg-0 text-center">
                  <img
                    class="eap-card-img bg-brand-secondary"
                    :src="card.img_url + getEAPServicesImage() + '.svg'"
                    alt="eap-type"
                    @click="goToService(card.title)"
                  />
                </div>
                <div class="col-12 col-lg-7 pl-1">
                  <div class="eap-card-content">
                    {{ card.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-white py-4 px-md-5 d-none d-lg-flex"
        v-if="
          pageData.defaults &&
            pageData.services_support &&
            pageData.services_support.active &&
            hasServices
        "
      >
        <div class="content-container row support justify-content-center">
          <div class="section-header">
            <div class="section-header-divider"></div>
            <h3 class="section-header-title" v-if="$store.getters.skin !== 25">
              {{ componentText.support }}
            </h3>
            <h3 class="section-header-title" v-else>What we can help with</h3>
          </div>
          <div
            v-for="serviceCard in pageData.services_support.items"
            v-if="serviceCard.active"
            class="eap-service-card col-md-5ths px-5 flex-grow-1"
          >
            <div class="service-card-img-container">
              <img class="service-card-img" :src="serviceCard.img_url" />
            </div>
            <div
              class="service-card-description bran"
              v-html="serviceCard.title"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="articles bg-white pb-5"
      v-if="pageData.defaults && pageData.defaults.articles"
    >
      <div class="content-container row">
        <div class="section-header section-header-right">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">{{ componentText.articles }}</h3>
        </div>
        <div v-for="(article, index) in articles" class="col-md-3 article-wrap">
          <a class="card" @click="selectArticle(article.post_id)">
            <div class="card-header bg-brand-primary">
              <img
                class="card-logo"
                :src="'/img/' + img_type[article.post_type]"
              />
            </div>
            <div class="card-body" ref="cardBody">
              <p class="card-title" ref="cardTitle">{{ article.post_type }}</p>
              <div class="card-text text-eclipse">{{ article.title }}</div>
            </div>
          </a>
          <div
            v-if="!$store.state.accessCode"
            :class="article.fav ? 'is-active ' : ''"
            @click="likeArticle(article.post_id, index)"
            class="card-heart"
          ></div>
        </div>
        <a
          class="home-link border-brand-secondary"
          @click="$router.push('/wellbeing/articles')"
          >{{ componentText.allArticles }}</a
        >
      </div>
    </div>
    <div v-if="callbackSelected" class="pop-up">
      <div class="pop-up-background" @click="hidePopUp"></div>
      <div class="pop-up-content bg-brand-secondary row">
        <div class="col-12">
          <h4>
            {{ pageData.defaults.eap_title }} {{ componentText.callbackTitle }}
          </h4>
          <div class="callback-form" v-if="!callBackSuccess">
            <div class="col-md-6 offset-md-3 ">
              <p>{{ componentText.select }}</p>
              <b-form-select class="form-control" v-model="selectedService">
                <option
                  v-for="(service, i) in filteredServices"
                  :key="i"
                  :value="service.id"
                  >{{ service.name }}</option
                >
              </b-form-select>
            </div>
            <div v-if="selectedService !== ''">
              <div class="service-description py-5 px-5">
                <p>{{ services[selectedService].content }}</p>
              </div>
              <div class="col-md-6 offset-md-3 pb-5">
                <p>{{ componentText.phone }}</p>
                <b-input
                  type="number"
                  class="form-control"
                  v-model="phoneNumber"
                  @keydown="testPhoneInput"
                ></b-input>
              </div>
              <div
                v-if="$store.getters.user.access_code_user"
                class="col-md-6 offset-md-3 pb-5"
              >
                <p>{{ componentText.accessCodeEmail }}</p>
                <b-input
                  v-model="accessCodeEmail"
                  class="form-control"
                  type="text"
                ></b-input>
              </div>
              <div
                v-if="$store.getters.user.access_code_user"
                class="col-md-6 offset-md-3 pb-5"
              >
                <p>{{ componentText.accessCodeName }}</p>
                <b-input
                  v-model="accessCodeName"
                  class="form-control"
                  type="text"
                ></b-input>
              </div>
              <div class="d-flex justify-content-center">
                <b-button
                  @click="requestCall"
                  class="cta-button px-5 py-3"
                  :disabled="
                    !$store.getters.user.access_code_user &&
                      phoneNumber.length < 7
                  "
                >
                  {{ componentText.callback }}</b-button
                >
              </div>
            </div>
          </div>
          <div class="callback-confirmation" v-if="callBackSuccess">
            {{
              $store.getters.subdomain === "landg"
                ? componentText.landg_thanks
                : componentText.thanks
            }}
          </div>
        </div>
        <b-button class="close-popup" @click="hidePopUp"
          ><font-awesome-icon icon="times-circle"></font-awesome-icon
        ></b-button>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as Sentry from "@sentry/vue";
import config from "../config/constants";
import { isVimeoUrl, buildVimeoEmbedUrl } from "@/utils/vimeoUrl/vimeoUrl";
import { trackEvent } from "@/utils/analytics/analytics";
import { EAP_LIVE_CHAT_OPENED } from "@/utils/analyticsEvents";
import { WEBCHAT_SCHEMA_VERSION } from "@/utils/webchat/webchat";
export default {
  name: "eap",
  data() {
    return {
      callbackSelected: false,
      selectedService: "",
      phoneNumber: "",
      accessCodeEmail: "",
      accessCodeName: "",
      callBackSuccess: false,
      pageData: {
        defaults: {
          eap_title: "EAP",
          live_chat: true,
        },
      },
      articles: [],
      img_type: {
        video: "video-white.svg",
        text: "blog-white.svg",
        image: "far fa-image",
        audio: "podcast-white.svg",
      },
      contentLoading: true,
      landg_eap: false,
      isDmhButtonShown: false,
      webchatMessageHandler: null,
      webchatPort: null,
    };
  },
  mounted() {
    this.getEapContent();
    this.getResourceList();
    const vm = this;
    // window.addEventListener("load", function(){
    //   if(window.$zopim) {
    //     window.$zopim.livechat.setLanguage(vm.$store.state.lang)
    //     window.$zopim.livechat.setGreetings({
    //       'online': vm.componentText.zendeskTitle,
    //     })
    //     window.$zopim.livechat.window.setTitle(vm.componentText.zendeskTitle)
    //     window.$zopim.livechat.prechatForm.setGreetings(vm.componentText.zendeskIntro)
    //   }
    // });
    if (this.$route.query.callback) {
      this.callbackSelected = true;
    }
  },
  destroyed() {
    const sf = document.getElementById("live-chat-widget");
    if (sf) sf.style.display = "none";
    const iframe = document.getElementById("twilio-webchat-iframe");
    if (iframe) iframe.style.display = "none";
    if (this.webchatMessageHandler) {
      window.removeEventListener("message", this.webchatMessageHandler);
      this.webchatMessageHandler = null;
    }
    // The iframe outlives this component (it lives on document.body); our end of the
    // channel doesn't — a revisit re-handshakes.
    if (this.webchatPort) {
      this.webchatPort.onmessage = null;
      this.webchatPort.close();
      this.webchatPort = null;
    }
    //remove zendesk
    // if(window.$zopim) {
    //   window.$zopim.livechat.hideAll()
    // }
  },
  methods: {
    getPhoneLink(phone) {
      if (phone[0].toLowerCase().includes("sms"))
        return "sms:" + decodeURIComponent(phone[1]);
      return "tel:" + decodeURIComponent(phone[1]);
    },
    goToService(title) {
      let searchTerm = title;
      switch (title) {
        case "Consumer adviser":
          searchTerm = "Consumer Advice";
          break;
        case "Support for non-nationals & their families":
          searchTerm = "Support for Non-Nationals";
          break;
        default:
          searchTerm = title;
      }
      const svc = this.filteredServices.filter(
        (item) =>
          item.name.toLowerCase().trim() === searchTerm.toLowerCase().trim(),
      );
      this.callbackSelected = true;
      this.selectedService = svc[0].id;
    },
    testPhoneInput(evt) {
      if (this.phoneNumber.toString().length > 14 && evt.key !== "Backspace") {
        console.log(this.phoneNumber.toString().length);
        evt.preventDefault();
      }
    },
    salesforceDemo() {
      let sf = document.getElementById("live-chat-widget");
      if (sf) {
        sf.style.display = "initial";
      } else {
        let script = document.createElement("script");
        script.src = "/assets/salesforce_Script.js";
        script.type = "text/javascript";
        script.charset = "UFT-8";
        script.setAttribute("id", "sf-script");
        document.head.appendChild(script);
      }
    },
    async initLiveChat() {
      let useTwilioFlex = false;
      try {
        // v2 is a deliberately new key: builds that shipped against the old
        // `eap_twilio_flex_chat_web` send an init the webchat now rejects, so that key
        // stays off permanently and leaves them on MessageBird.
        const res = await this.api({
          path: "api/u/feature-flag",
          feature_flags: ["eap_twilio_flex_web_chat_v2"],
        });
        useTwilioFlex = !!(
          res &&
          res.feature_flags &&
          res.feature_flags.eap_twilio_flex_web_chat_v2
        );
      } catch {
        useTwilioFlex = false;
      }
      if (useTwilioFlex) {
        this.loadTwilioWebchat();
      } else {
        this.salesforceDemo();
        trackEvent(EAP_LIVE_CHAT_OPENED, { provider: "messagebird" });
      }
    },
    loadTwilioWebchat() {
      // VUE_APP_REGION / VUE_APP_WEBCHAT_URL absent or invalid — a build misconfiguration.
      // Refuse rather than guess the region (wrong Flex account) or throw on new URL()
      // below (CR-126).
      if (!config.webchat_region || !config.webchat_url) {
        Sentry.captureMessage(
          "Not opening Twilio webchat: VUE_APP_REGION or VUE_APP_WEBCHAT_URL missing/invalid",
          { level: "error", tags: { stage: "webchat_config" } },
        );
        return;
      }
      const webchatOrigin = new URL(config.webchat_url).origin;
      let iframe = document.getElementById("twilio-webchat-iframe");
      // Reuse a warm iframe from an earlier visit; fall through (don't return) to
      // re-attach the listener destroyed() removed, else resize dies on revisit.
      const isWarmIframe = Boolean(iframe);
      if (iframe) {
        iframe.style.display = "block";
      } else {
        // Embed the hosted webchat, driven via the webchat:* contract
        // (mirrors live-webchat/src/contracts/embed.ts).
        iframe = document.createElement("iframe");
        iframe.id = "twilio-webchat-iframe";
        const webchatUrl = new URL(config.webchat_url);
        // Clear the bottom-right a11y widget: 72 = its ~56px + a 16px gap; 16 off the edge.
        webchatUrl.searchParams.set("offsetBottom", "72");
        webchatUrl.searchParams.set("offsetRight", "16");
        iframe.src = webchatUrl.toString();
        iframe.title = "Live chat";
        // allow-scripts + allow-same-origin is only self-defeating for a SAME-origin
        // frame, which could reach our DOM and drop the attribute; this embed is
        // cross-origin. Both are needed anyway — an opaque origin breaks the SDK's
        // localStorage and sends its API calls with a null origin.
        // The value is in what's withheld, above all allow-top-navigation. popups and
        // downloads are for links and attachments in a conversation — retest before
        // dropping either.
        iframe.setAttribute(
          "sandbox",
          "allow-scripts allow-same-origin allow-forms allow-popups allow-downloads",
        );
        // Deny device APIs the webchat never needs.
        iframe.setAttribute("allow", "clipboard-write");
        document.body.appendChild(iframe);
      }

      // Re-attach each call (destroyed() removes it); drop any stale listener first.
      if (this.webchatMessageHandler) {
        window.removeEventListener("message", this.webchatMessageHandler);
      }
      // Only webchat:ready arrives over the window: it's the signal to open the channel,
      // so it can't travel over a port that doesn't exist yet. Everything else uses the
      // port (CR-130).
      const handler = (event) => {
        if (event.origin !== webchatOrigin) return;
        const message = event.data;
        if (!message || typeof message !== "object") return;
        if (message.type !== "webchat:ready") return;
        // A contract this build doesn't speak — ignore rather than half-understand it.
        if (message.v !== WEBCHAT_SCHEMA_VERSION) return;
        // Apply the offsets the webchat resolved (floating presentation only).
        if (typeof message.offsetBottom === "number") {
          iframe.style.setProperty(
            "--webchat-offset-bottom",
            `${message.offsetBottom}px`,
          );
        }
        if (typeof message.offsetRight === "number") {
          iframe.style.setProperty(
            "--webchat-offset-right",
            `${message.offsetRight}px`,
          );
        }
        this.openWebchatChannel(iframe, webchatOrigin);
      };
      window.addEventListener("message", handler);
      this.webchatMessageHandler = handler;

      // A warm iframe already loaded and will never emit webchat:ready again, so open the
      // channel ourselves. The receiver swaps to the newest port, keeping its session.
      if (isWarmIframe) {
        this.openWebchatChannel(iframe, webchatOrigin);
      }
    },
    // Opens a private MessageChannel with the webchat and sends init over it, so the
    // token never crosses the broadcast window surface (CR-130 / receiver CR-129).
    openWebchatChannel(iframe, webchatOrigin) {
      if (!iframe.contentWindow) return;
      if (this.webchatPort) {
        this.webchatPort.onmessage = null;
        this.webchatPort.close();
      }
      const channel = new MessageChannel();
      this.webchatPort = channel.port1;
      channel.port1.onmessage = (event) =>
        this.onWebchatPortMessage(event.data, iframe);
      // port2 goes to the webchat; origin still pinned, and no payload on this message.
      iframe.contentWindow.postMessage(
        { type: "webchat:connect", v: WEBCHAT_SCHEMA_VERSION },
        webchatOrigin,
        [channel.port2],
      );
      // user_id is the oath_token — validated server-side, never sent to Twilio.
      // autoOpen:false: web starts collapsed (this load is a side effect, not a
      // click); the RN app passes true.
      channel.port1.postMessage({
        type: "webchat:init",
        v: WEBCHAT_SCHEMA_VERSION,
        token: this.$store.getters.user_id,
        displayMode: "widget",
        autoOpen: false,
        // One deployment serves every QA env — tell it which backend issued the token.
        apiBaseUrl: new URL(config.api_env).origin,
        // Selects that region's Twilio config; derived from the same api_env (CR-126).
        region: config.webchat_region,
      });
    },
    onWebchatPortMessage(message, iframe) {
      if (!message || typeof message !== "object") return;
      if (message.v !== WEBCHAT_SCHEMA_VERSION) return;
      switch (message.type) {
        case "webchat:expanded":
          // CSS media query picks floating vs full-screen (see .expanded); JS just toggles.
          iframe.classList.add("expanded");
          // Fire on real open (autoOpen:false → this expand is the user's first open).
          trackEvent(EAP_LIVE_CHAT_OPENED, { provider: "twilio_flex" });
          break;
        case "webchat:collapsed":
          iframe.classList.remove("expanded");
          break;
        case "webchat:error":
          // Couldn't boot (bad token, unprovisioned region, outage). Report it and take
          // the dead iframe down rather than leave an invisible overlay on the page.
          Sentry.captureMessage(
            `Twilio webchat failed to boot: ${message.code || "unknown"}`,
            {
              level: "error",
              tags: { stage: "webchat_error", code: message.code || "unknown" },
              extra: { message: message.message },
            },
          );
          iframe.classList.remove("expanded");
          iframe.style.display = "none";
          break;
      }
    },
    log() {
      console.log(this.pageData.services_offered.items);
    },
    callBack() {
      this.callbackSelected = true;
    },
    async getEapContent() {
      const payload = {
        user_id: this.$store.getters.user_id,
      };
      let res = await axios.post(
        config.api_env + "/application/api/u/customisations/get-eap-content",
        payload,
        config.options,
      );
      if (res.data.success) {
        this.pageData = res.data.eap_customisation;
        this.landg_eap = res.data.landg_eap;
        this.contentLoading = false;
        this.isDmhButtonShown = res.data.eap_customisation?.dmh_button;
      }
      if (this.pageData.defaults.live_chat) {
        this.initLiveChat();
      }
    },
    async getResourceList() {
      const payload = {
        user_id: this.$store.getters.user_id,
        search_key: "",
        filter: "",
        tag: "mind",
        fav_only: "0",
        page: "0",
        page_size: "4",
        surge_only: 1,
      };
      let res = await axios.post(
        config.api_env + "/application/api-hc/get-all-resource-list",
        payload,
        config.options,
      );
      if (res.data.success) {
        this.articles = res.data.resources;
      }
    },
    async likeArticle(articleId, index) {
      const payload = {
        user_id: this.$store.getters.user_id,
        type: "module",
        resource_id: articleId,
      };
      if (!this.articles[index].fav) {
        this.articles[index].fav = 1;
        let res = await axios.post(
          config.api_env + "/application/api-hc/like-item",
          payload,
          config.options,
        );
        if (!res.data.success) {
          this.articles[index].fav = 0;
        }
      } else {
        this.articles[index].fav = 0;
        let res = await axios.post(
          config.api_env + "/application/api-hc/unlike-item",
          payload,
          config.options,
        );
        if (!res.data.success) {
          this.articles[index].fav = 1;
        }
      }
    },
    selectArticle(articleId) {
      this.$router.push("/wellbeing/article/" + articleId).catch((err) => {});
    },
    bookDmhSession() {
      this.$router.push("/session-booking?service_type=sl_dmh");
    },
    async requestCall() {
      let payload = {
        user_id: this.$store.getters.user_id,
        phone: this.phoneNumber,
        service_id: this.selectedService,
      };
      if (this.$store.getters.user.access_code_user) {
        payload.name = this.accessCodeName;
        payload.email = this.accessCodeEmail;
      }
      let res = await axios.post(
        config.api_env + "/application/api-hc/send-eap-request",
        payload,
        config.options,
      );
      if (res.data.sent) {
        this.callBackSuccess = true;
      }
    },
    hidePopUp() {
      this.callbackSelected = false;
      this.selectedService = "";
      this.callBackSuccess = false;
    },
    getEAPServicesImage() {
      if (this.$store.getters.skin === 0) {
        return "";
      } else if (this.$store.getters.skin === 10) {
        return "-laya";
      }
      return "-generic";
    },

    enableZendeskWidget() {
      //   let key = "231b7a97-95a0-4837-86a2-5be70b3b9db1";
      let key = "970fec74-4d7c-4d50-8479-05468b79e57a";
      // the if statement below changes the ZenDesk key for L&G users
      if (this.landg_eap) {
        key = "a04aaa15-6e9e-4947-a98d-e5560870d7a9";
      }
      window.$zopim ||
        (function(d, s) {
          var z = (window.$zopim = function(c) {
              z._.push(c);
            }),
            $ = (z.s = d.createElement(s)),
            e = d.getElementsByTagName(s)[0];
          z.set = function(o) {
            z.set._.push(o);
          };
          z._ = [];
          z.set._ = [];
          $.async = !0;
          $.setAttribute("charset", "utf-8");
          $.setAttribute("id", "ze-snippet");
          $.src = "https://static.zdassets.com/ekr/snippet.js?key=" + key;
          z.t = +new Date();
          $.type = "text/javascript";
          e.parentNode.insertBefore($, e);
        })(document, "script");
    },
  },
  computed: {
    componentText() {
      return this.getText.loggedIn.eap;
    },
    skin() {
      return this.$store.getters.skin;
    },
    isVimeoVideo() {
      return isVimeoUrl(this.pageData.defaults.video_url);
    },
    vimeoEmbedUrl() {
      return buildVimeoEmbedUrl(this.pageData.defaults.video_url);
    },
    services() {
      return [
        {
          id: 0,
          name: this.componentText.mentalWellbeing,
          content: this.componentText.mentalWellbeingContent,
        },
        {
          id: 1,
          name: this.componentText.finance,
          content: this.componentText.financeContent,
        },
        {
          id: 2,
          name: this.componentText.life,
          content: this.componentText.lifeContent,
        },
        {
          id: 3,
          name: this.componentText.career,
          content:
            this.componentText.careerContent1 +
            this.pageData.defaults.eap_title +
            this.componentText.careerContent2,
        },
        {
          id: 4,
          name: this.componentText.consumer,
          content:
            this.componentText.consumerContent1 +
            this.pageData.defaults.eap_title +
            this.componentText.consumerContent2,
        },
        {
          id: 5,
          name: this.componentText.mediation,
          content: this.componentText.mediationContent,
        },
        {
          id: 6,
          name: this.componentText.nonNationals,
          content: this.componentText.nonNationalsContent,
        },
        {
          id: 7,
          name: this.componentText.legal,
          content:
            this.componentText.legalContent1 +
            this.pageData.defaults.eap_title +
            this.componentText.legalContent2,
        },
        {
          id: 8,
          name: this.componentText.medical,
          content: this.componentText.medicalContent,
        },
        {
          id: 9,
          name: this.componentText.menopause,
          content: this.componentText.menopauseContent,
        },
        {
          id: 10,
          name: this.componentText.parentalAdvice,
          content: this.componentText.parentalAdviceContent,
        },
      ];
    },
    filteredServices() {
      let services = [];
      for (let i = 0; i < this.pageData.services_offered.items.length; i++) {
        if (this.pageData.services_offered.items[i].active) {
          let svc = null;
          switch (this.pageData.services_offered.items[i].title) {
            case "Mental wellbeing support":
              svc = this.services[0];
              break;
            case "Financial assistance":
              svc = this.services[1];
              break;
            case "Life coaching":
              svc = this.services[2];
              break;
            case "Career counselling":
              svc = this.services[3];
              break;
            case "Consumer adviser":
              svc = this.services[4];
              break;
            case "Mediation":
              svc = this.services[5];
              break;
            case "Support for non-nationals & their families":
              svc = this.services[6];
              break;
            case "Legal assistance":
              svc = this.services[7];
              break;
            case "Parental advice":
              svc = this.services[9];
              break;
            case "Menopause support":
              svc = this.services[10];
              break;
          }
          services.push(svc);
        }
      }
      return services;
    },
    hasServices() {
      let hasServices = false;
      for (let i = 0; i < this.pageData.services_support.items.length; i++) {
        if (this.pageData.services_support.items[i].active) {
          hasServices = true;
        }
      }
      return hasServices;
    },
  },
};
</script>
<style lang="less">
#eap {
  .numbersBanner {
    width: 100%;
    margin-top: 40px;
    padding: 25px 30px;

    .innerBanner {
      display: grid;
      grid-template-columns: 3fr 2fr;
    }

    .phoneNumberContainer {
      max-width: 700px;
      row-gap: 15px;
      display: flex;
      flex-wrap: wrap;

      .phoneNumber {
        color: white !important;
        min-width: 220px;
        padding-right: 20px;
        font-family: DMSans, Arial, Helvetica, sans-serif;
        font-size: 16px;
        cursor: pointer;

        a {
          color: white !important;
        }
      }
    }
  }

  .btn-continue {
    min-width: 228px;
    min-height: 48px;
    width: fit-content;
    font-family: "DMSans Bold";
    letter-spacing: normal;
    background-color: var(--brand-primary);
    border-radius: 5px;
    color: #ffffff;
    padding: 8px 24px;
    font-weight: 700;
    font-size: 1.6rem;
    margin-bottom: 12px;

    &.dmh-button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
    }

    .fa {
      margin-left: 16px;
      font-size: 2rem;
      background-color: #ffffff;
      border-radius: 5px;
      padding: 8px;
    }
  }

  .link-btn-container {
    padding: 20px 16px;
  }

  .link-btn {
    font-family: "DMSans Bold";
    color: #fff;
    font-weight: 700;
    font-size: 1.6rem;
    background: transparent;
    width: max-content;
    border: none;
    padding: 20px 0;
    text-transform: uppercase;
    color: var(--brand-primary);

    &:hover {
      text-decoration: underline;
    }
  }

  .page-header {
    padding: 60px 0;

    .page-title {
      text-align: left;

      h2 {
        text-align: left;
        font-size: 3.8rem;
        letter-spacing: 0.7rem;
        font-family: "FilsonProBold", sans-serif;
        color: #fff;
      }

      p {
        font-size: 2rem;
        font-family: "DMSans";
        color: #fff;

        a {
          color: #fff;
        }
      }
    }

    .call-us {
      text-align: right;

      img {
        max-width: 220px;
      }

      h3 {
        font-family: "FilsonProLight";
        font-size: 3.2rem;
        letter-spacing: 0;
        color: #fff;
        font-weight: 100;
        padding-top: 20px;
      }

      .btn {
        font-size: 1.3rem;
        font-family: "FilsonProBold";
      }
    }

    .video-wrap {
      border-radius: 20px;
      -o-object-fit: fill;
      object-fit: fill;

      .video {
        -o-object-fit: fill;
        object-fit: fill;
        border-radius: 20px;

        &:focus {
          outline: none;
        }
      }

      iframe.video {
        display: block;
        width: 100%;
        aspect-ratio: 16 / 9;
        border: none;
      }
    }

    .video-player {
      max-width: 550px;
      text-align: center;
      margin: auto;
    }
  }

  .services-offered {
    justify-content: center;
  }

  .eap-cards {
    .eap-card {
      .eap-card-img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
        max-width: 100px;
        cursor: pointer;
      }

      .eap-card-content {
        font-family: FilsonProLight, sans-serif;
        font-size: 1.8rem;
        line-height: 2.3rem;
        letter-spacing: 0;

        @media (max-width: 992px) {
          text-align: center;
        }
      }
    }
  }

  .eap-service-card {
    &:not(:last-of-type)::after {
      content: "";
      position: absolute;
      top: 70%;
      right: 0;
      width: 1px;
      height: 30%;
      transform: translateY(-50%);
      background: #cccccc;
    }

    .service-card-img-container {
      height: 90px;

      .service-card-img {
        height: 90px;
        transform: translateX(25%);
        width: 65%;
        z-index: 2;
      }
    }

    .service-card-description {
      font-family: DMSans, sans-serif;
      margin-top: 20px;
      font-size: 1.8rem;
      line-height: 1.2;
      text-align: center;
      letter-spacing: 0;
    }
  }

  .support {
    padding-bottom: 80px;
  }

  .pop-up {
    display: flex;
    align-items: center;
    z-index: 500;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;

    .pop-up-content {
      max-width: 636px;
      width: 100%;
      margin: auto;
      border-radius: 25px;
      padding: 50px 20px;
      font-size: 1.6rem;
      text-align: center;
      z-index: 10;
      color: #fff;
      position: relative;

      p {
        color: #fff;
      }

      h4 {
        font-family: "FilsonProBold", sans-serif;
        font-size: 3.8rem;
        color: #fff;
      }

      .form-control {
        height: 30px;
        border-radius: 5px;
        font-size: 1.6rem;
      }

      .service-description {
        text-align: left;
      }

      .close-popup {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        background-color: transparent;
        width: 50px;
        height: 50px;

        svg {
          width: 30px;
          height: 30px;
        }
      }
    }

    .pop-up-background {
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 0;
      right: 0;
      z-index: 5;
      background: transparent;
    }
  }

  .articles {
    .article-wrap {
      position: relative;

      .card-heart {
        background-image: url("/img/heart-line_white.svg");
        position: absolute;
        width: 30px;
        height: 26px;
        top: 15px;
        right: 30px;
        background-size: cover;
        cursor: pointer;

        &.is-active {
          background-image: url("/img/heart_white.svg");
        }
      }
    }

    .card {
      position: relative;
      box-sizing: border-box;
      margin-bottom: 36px;
      transition: 0.3s ease-out;
      border: none;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      font-family: "FilsonProLight", sans-serif;
      border-radius: 10px;

      &:hover {
        cursor: pointer;
        text-decoration: none;
        box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.6);
      }

      .card-header {
        border-radius: 2px 2px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 150px;
        border-radius: 10px 10px 0 0;

        .card-logo {
          max-height: 60%;
          max-width: 55%;
        }
      }

      .card-body {
        width: 100%;
        height: 110px;
        box-sizing: border-box;
        padding: 10px 10px 20px;
        background: #ffffff;
        text-align: center;
        border-radius: 0 0 10px 10px;

        .card-title {
          font-family: FilsonProLight, sans-serif;
          margin: 0;
          padding: 0 0 10px;
          font-size: 1.6rem;
          text-align: center;
          text-transform: uppercase;
          opacity: 0.5;
        }

        .card-text {
          margin: 0;
          padding: 0;
          font-family: FilsonProLight, sans-serif;
          font-size: 1.8rem;
          line-height: 1;
          text-align: center;
        }
      }
    }
  }

  @media only screen and (max-width: 992px) {
    .numbersBanner {
      .innerBanner {
        grid-template-columns: 1fr;
      }

      .phoneNumberContainer {
        .phoneNumber {
          width: 100%;
          text-align: center;
        }

        max-width: unset;
        margin-bottom: 25px;
      }
    }

    .link-btn-container {
      text-align: center;
    }
  }
}

// Twilio webchat iframe — appended to <body>, so top-level (not under #eap).
// This id must match the one set on the iframe in loadTwilioWebchat().
#twilio-webchat-iframe {
  position: fixed;
  // Offsets from the webchat (16px default, per-consumer override echoed on
  // webchat:ready), raised to clear the ~56px bottom-right a11y widget.
  right: var(--webchat-offset-right, 16px);
  bottom: var(--webchat-offset-bottom, 16px);
  width: 40px;
  height: 40px;
  border: 0;
  z-index: 100000;
  background: transparent;

  // Floating corner panel; max-height keeps it clip-free above Twilio's ~646px window.
  &.expanded {
    width: 400px;
    height: 700px;
    max-height: calc(100vh - 80px);
  }

  // Narrow/short viewport: stretch to fill above the a11y widget. Keep right/bottom
  // (the vars) so the corner stays anchored on expand — only top/left move.
  @media (max-width: 600px), (max-height: 725px) {
    &.expanded {
      top: 16px;
      left: 16px;
      right: 16px;
      // iframes don't fill via height:auto (defaults to 150px) — set them explicitly.
      width: calc(100vw - 32px);
      height: calc(100vh - var(--webchat-offset-bottom, 16px) - 16px);
      max-height: none;
    }
  }
}
</style>
